import { LoadingButton } from '@mui/lab';
import {
  Button,
  IconButton,
  Stack,
  ToggleButton,
  Typography,
  styled,
} from '@mui/material';

export const AddButton = styled(IconButton)`
  width: 44px;
  height: 44px;
  padding: 0px;
  color: #fff;
  background-color: #5546a9;
  &:hover,
  &:focus,
  &:active {
    background-color: #5546a9;
  }
  position: fixed;
  right: 20px;
  box-shadow: 0px 3.473684072494507px 8.105263710021973px 0px #00000024;
`;

export const ZoomAndLocationButton = styled(IconButton)`
  width: 40px;
  height: 40px;
  padding: 0px;
  background-color: #fff;
  &:hover,
  &:focus,
  &:active {
    background-color: #fff;
  }
  box-shadow: 0px 3.473684072494507px 8.105263710021973px 0px #00000024;
`;

export const PrimaryButton = styled(Button)`
  border-radius: 30px;
  background: #5546a9;
  box-shadow: 0px 4px 14px 0px rgba(0, 0, 0, 0.06);
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  &:hover,
  &:focus,
  &:active {
    background: #5546a9;
  }
  flex: 1;
  padding: 10px 20px;
`;

export const PrimaryOutlinedButton = styled(Button)`
  border-radius: 30px;
  border: 1px solid #5546a9;
  background: #fff;
  box-shadow: 0px 4px 14px 0px rgba(0, 0, 0, 0.06);
  color: #5546a9;
  font-size: 14px;
  font-weight: 700;
  &:hover,
  &:focus,
  &:active {
    background: #fff;
  }
  flex: 1;
  padding: 10px 20px;
`;

export const InspectionToggleButton = styled(ToggleButton)`
  margin-bottom: 18px;
  height: 40px;
  border-radius: 30px !important;
  border: 1px solid #e7e5e9 !important;
  &.Mui-selected,
  &.Mui-selected:hover {
    color: #5546a9;
    background-color: #f5f7fe;
  }
`;

export const InspectionStatus = styled(Stack)`
  flex-direction: row;
  justify-content: space-between;
  width: 96%;
  align-items: center;
`;

export const StatusToggleButton = styled(ToggleButton)`
  height: 40px;
  border-radius: 30px !important;
  border: 1px solid #e7e5e9 !important;
  &.Mui-selected,
  &.Mui-selected:hover {
    color: #5546a9;
    background-color: #f5f7fe;
  }
`;

export const WarningButton = styled(Button)`
  border-radius: 30px;
  border: 1px solid #db2828;
  opacity: 0.800000011920929;
  color: #db2828;
  font-size: 14px;
  font-weight: 700;
  line-height: 100%;
  &:hover,
  &:focus,
  &:active {
    background: #fff;
  }
  flex: 1;
  padding: 10px 20px;
`;

export const WarningLoadingButton = styled(LoadingButton)`
  border-radius: 30px;
  background-color: #db2828;
  opacity: 0.800000011920929;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  line-height: 100%;
  &:hover,
  &:focus,
  &:active {
    background: #db2828;
  }
  flex: 1;
  padding: 10px 20px;
`;

export const PrimaryLoadingButton = styled(LoadingButton)`
  border-radius: 30px;
  background: #5546a9;
  box-shadow: 0px 4px 14px 0px rgba(0, 0, 0, 0.06);
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  &:hover,
  &:focus,
  &:active {
    background: #5546a9;
  }
  flex: 1;
  padding: 10px 20px;
`;

export const TableButton = styled(Button)`
  border-radius: 4px;
  border: 1px solid #5546a9;
  color: #5546a9;
  font-size: 12px;
  padding: 4px;
  &:hover,
  &:focus,
  &:active {
    background: #fff;
  }
`;

export const TableWarningButton = styled(Button)`
  border-radius: 4px;
  border: 1px solid #db2828;
  color: #db2828;
  font-size: 12px;
  padding: 4px;
  &:hover,
  &:focus,
  &:active {
    background: #fff;
  }
`;

export const SecondaryTextButton = styled(Button)`
  color: #25b5be;
  font-size: 14px;
  font-weight: 700;
  line-height: 100%;
  text-decoration-line: underline;
  &:hover,
  &:focus,
  &:active {
    background: #fff;
  }
`;

export const TetraPrimaryButton = styled(Button)`
  border-radius: 4px;
  border: 1px solid #5546a9;
  color: #5546a9;
  font-size: 14px;
  &:hover,
  &:focus,
  &:active {
    background: #fff;
  }
`;

export const TetraPrimaryLoadingButton = styled(LoadingButton)`
  border-radius: 4px;
  border: 1px solid #5546a9;
  color: #5546a9;
  font-size: 14px;
  &:hover,
  &:focus,
  &:active {
    background: #fff;
  }
`;

export const PrimaryColorButton = styled(Button)`
  border-radius: 4px;
  background: #5546a9;
  color: #fff;
  font-size: 14px;
  &:hover,
  &:focus,
  &:active {
    background: #5546a9;
  }
`;

export const BulkUploadButton = styled(Button)`
  border-radius: 30px;
  background: #5546a91a;
  color: #5546a9;
  font-size: 16px;
  font-weight: 500;
  &:hover,
  &:focus,
  &:active {
    background: #5546a91a;
  }
  flex: 1;
  width: 200px;
  padding: 10px 20px;
`;

export const GrayButton = styled(Button)`
  border-radius: 6px;
  border: 1px solid #e7e5e9;
  background: #f8f8f8;
  color: #48464c;
  font-size: 14px;
  font-weight: 500;
  &:hover,
  &:focus,
  &:active {
    background: #f8f8f8;
  }
`;

export const LogoButton = styled(Button)`
  width: 152px;
  background: #fff;
  &:hover,
  &:focus,
  &:active {
    background: #fff;
  }
`;

export const AttachmentText = styled(Typography)`
  color: #79767d;
  font-size: 14px;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 200px;
`;
